import { useBillingSettings } from '@/state/billing/useBillingSettings';
import { CurrentPlanCard } from './CurrentPlanCard';
import { PlansPanel } from './PlansPanel';
import { AgencyFeePanel } from './AgencyFeePanel';
import { UsageSummary } from './UsageSummary';
import { UsageChart } from './UsageChart';
import { ClientBillingTable } from './ClientBillingTable';
import { AiCreditsCard } from './AiCreditsCard';
import { InvoicesTable } from './InvoicesTable';
import { UsageReportPanel } from './UsageReportPanel';

/**
 * Settings > Billing. Every decision about what to show lives in
 * useBillingSettings; each panel renders its own loading and error line, so
 * the page never blanks while one request is slow or has failed.
 *
 * Polar's return from checkout (`?checkout=plan|topup`) is handled by
 * useCheckoutReturn, run from the ActivationBanner for the whole session.
 */
export const SettingsBilling = () => {
  const manager = useBillingSettings();
  const { showPlans, showTokens, showClients, showInvoices, showUsageReport } = manager;

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-[14px]">
      <CurrentPlanCard manager={manager} />
      {manager.showAgencyFee && <AgencyFeePanel />}
      <UsageSummary manager={manager} />
      {showTokens && <AiCreditsCard manager={manager} />}
      {showPlans && (
        <PlansPanel
          key={manager.accountId ?? 'self'}
          accountId={manager.accountId}
          accountName={manager.selectedClientName}
        />
      )}
      {showClients && <ClientBillingTable manager={manager} />}
      <UsageChart manager={manager} />
      {showInvoices && <InvoicesTable manager={manager} />}
      {showUsageReport && <UsageReportPanel manager={manager} />}
    </div>
  );
};
